export class InvitationProvider
{
	invite(): Promise
	{
		throw new Error('Implement the method "invite" in the child class');
	}
}
